<template>
    <div class="block sm:hidden">
        <div class="flex mobile-top">
            <div class="pt-6 w-24 pl-4">
                <img class="w-4" src="@/assets/arrow/back.png" @click="clickBack()">
            </div>
            <div class="pt-4 flex-grow">
                <img class="logo-mobile-size m-auto" src="@/assets/logo/tipcoin-logo-top.png">
            </div>
            <div class="pt-4 mr-1 w-24 h-12">
                <SwitchLang></SwitchLang>
            </div>
        </div>
    </div>
</template>

<script>
import SwitchLang from '@/components/Input/simple/SwitchLang.vue'
export default {
    name: 'TopbarBackLang',
    components:{
        SwitchLang
    },
    props: {
        routeBack: { type:String , default: '' }
    },
    data() {
        return {

        };
    },

    mounted() {

    },

    methods: {
        clickBack: function(){
            if(this.routeBack){
                this.$router.replace(this.routeBack)
            } else {
                this.$router.back();
            }
        }
    },
};
</script>

<style lang="scss" scoped>
@import "@/style/base/base.scss";
.logo-size {
    width: 100px;
    height: 90px;
}
.logo-mobile-size {
    width: 65px; //53px
    height: 58px;
}
.mobile-top {
    height: $topbar-height-mobile;
}
</style>
